import React from 'react'
import PropTypes from 'prop-types'
import { intl } from 'lang/intl'

import { Toggle } from '../../../../components'
import { WebinarPanelComponent } from '../index'

import './WebinarSidebarQuestionsPanelComponent.scss'

const WebinarSidebarQuestionsPanelComponent = (props) => {
  const {
    children,
    toggleQuestionsMode,
    isQuestionsEnabled,
    isShowingPermissionToggle,
  } = props

  const toggleLabel = intl.formatMessage({
    defaultMessage: 'Audience can ask questions',
  })

  return (
    <>
      {isShowingPermissionToggle && (
        <WebinarPanelComponent>
          <div className="questions-mode-toggle-wrapper">
            <span>{toggleLabel}</span>
            <Toggle
              onChange={toggleQuestionsMode}
              toggled={isQuestionsEnabled}
              ariaLabel={toggleLabel}
            />
          </div>
        </WebinarPanelComponent>
      )}
      <div className="questions-wrapper">{children}</div>
    </>
  )
}

WebinarSidebarQuestionsPanelComponent.propTypes = {
  toggleQuestionsMode: PropTypes.func,
  isQuestionsEnabled: PropTypes.bool,
  children: PropTypes.node,
  isShowingPermissionToggle: PropTypes.bool,
}

WebinarSidebarQuestionsPanelComponent.defaultProps = {
  isShowingPermissionToggle: false,
}

export default WebinarSidebarQuestionsPanelComponent
